import dayjs from 'dayjs';

import CancelOrder from '@/components/CancelOrder/CancelOrder.vue';
import WDateTimeDisplay from '@/components/WDateTimeDisplay/WDateTimeDisplay.vue';
import {
  GROUP_BUYING_STATUS,
  RECEIVE_STATUS,
} from '@/utils/constants';
import { getWeekString } from '@/utils/helper';

export default {
  name: 'OrderCard',
  components: {
    CancelOrder,
    WDateTimeDisplay,
  },
  props: {
    item: {
      default: () => ({}),
      type: Object,
    },
    borderColor: {
      default: 'border-l-primary-400',
      type: String,
    },
    orderCanceled: {
      default: false,
      type: Boolean,
    },
    showCancelButton: {
      default: true,
      type: Boolean,
    },
    showEndTimeString: {
      default: true,
      type: Boolean,
    },
  },
  data() {
    return {
      cancelOrderName: '',
      cancelOrderData: {},
      isCollapsed: true,
      showCancel: false,
    };
  },
  computed: {
    RECEIVE_STATUS() {
      return RECEIVE_STATUS;
    },
    endTimeString() {
      const { end_time: endTime } = this.item;
      return `訂購截止時間：${dayjs(endTime).format('MM/DD')}
        ${this.getWeek(endTime)}
        ${dayjs(endTime).format('HH:mm')}`;
    },
    isEnded() {
      return this.item.status === GROUP_BUYING_STATUS.END;
    },
    inProgress() {
      return this.item.status === GROUP_BUYING_STATUS.IN_PROGRESS;
    },
    inScheduled() {
      return this.item.status === GROUP_BUYING_STATUS.SCHEDULED;
    },
    memberOrders() {
      const { member_orders: list = [] } = this.item || {};
      if (!list.length) {
        return [];
      }
      return this.isCollapsed ? [list[0]] : list;
    },
    startTimeString() {
      const { start_time: startTime } = this.item;
      return `開始訂購：${dayjs(startTime).format('MM/DD')}
        ${this.getWeek(startTime)}
        ${dayjs(startTime).format('HH:mm')}`;
    },
    showCollapsed() {
      const { member_orders: memberOrders = [] } = this.item || {};
      const { order_contents: orderContents = [] } = memberOrders[0] || {};
      return memberOrders.length > 1 || orderContents.length > 1;
    },
  },
  methods: {
    dayjs,
    getDateTimeText(time = '') {
      return dayjs(time).format('MM/DD HH:mm');
    },
    getOrderTotal(order) {
      const totalWithComma = this.$options.filters.commaFormat(order.total);
      const totalWithPriceSign = this.$options.filters.priceFormat(totalWithComma);
      return this.orderCanceled ? '-' : totalWithPriceSign;
    },
    getOptionItems({ options = [] }) {
      return options.map(({ items = [] }) => items.map(({ name }) => name).join(', ')).join(', ');
    },
    cancelOrder(order, storeName) {
      this.cancelOrderData = order;
      this.cancelOrderName = storeName;
      this.showCancel = true;
    },
    onCancelSuccess(res) {
      Object.assign(this.cancelOrderData, res);
    },
    getWeek(time) {
      return time ? getWeekString(time) : '';
    },
    getOrderContents(order) {
      const { order_contents: list = [] } = order || {};
      if (!list.length) {
        return [];
      }
      return this.isCollapsed ? [list[0]] : list;
    },
    isCancelledOrder(order) {
      return order.status === RECEIVE_STATUS.CANCELED;
    },
  },
};
